// eslint-disable-next-line no-undef
APP.BurgerMenu = function (menuButtonSel, navItemsSel) {
  this.menuButtonSel = menuButtonSel;
  this.navItemsSel = navItemsSel;

  this._render();
};

// eslint-disable-next-line no-undef
APP.BurgerMenu.prototype._createOption = function (options) {
  var option = document.createElement('option');
  for (var p in options) {
    option[p] = options[p];
  }
  return option;
};

// eslint-disable-next-line no-undef
APP.BurgerMenu.prototype._render = function () {
  var menuButton = document.querySelector(this.menuButtonSel);
  var navItems = document.querySelectorAll(this.navItemsSel);

  if (menuButton && navItems) {
    var select = document.createElement('select');
    var group = document.createElement('optgroup');

    group.label = 'Přejít na:';

    Array.prototype.slice.call(navItems).forEach(
      function (item) {
        var option = this._createOption({
          text: item.textContent,
          value: item.getAttribute('href'),
          selected: item.parentElement.classList.contains('active'),
        });
        group.appendChild(option);
      }.bind(this)
    );

    select.appendChild(group);

    select.addEventListener('change', function () {
      window.location = select.options[select.selectedIndex].value;
    });

    menuButton.appendChild(select);
  }
};
